import React, { useCallback } from 'react';
import { Input } from '@cognitiv/cyprus-ui';
import { ParametersProps } from 'ducks/types/prop-types';
import { useJobDefinitionContext } from 'modals/job-definition/context/JobDefinitionContext';
import { Parameters } from 'modals/parameters/components/Parameters';

export const JobDefinitionParameters = ({ setParameters, parameters, force_update }: ParametersProps) => {
  const {
    form: { batch_descriptor },
    onChange,
  } = useJobDefinitionContext();

  const onBatchDescriptorChange = useCallback((item: string) => onChange({ batch_descriptor: item }), [onChange]);

  return (
    <>
      <Input
        label="Batch Descriptor"
        value={batch_descriptor}
        margin="0px 0px 16px 0px"
        onChange={onBatchDescriptorChange}
      />
      <Parameters force_update={force_update} setParameters={setParameters} parameters={parameters} />
    </>
  );
};
